<template>
  <!-- NOTE (TEMPLATE) to show & edit reasercher profile -->

  <div class="animated fadeIn">
    <!-- loading component -->
    <Loading />

    <b-card style="border: 0" class="mt-0 mb-0" header-bg-variant="primary">
      <template v-slot:header>
        <h4>تغییر رمز عبور</h4>
      </template>
      <b-form-group label="رمز عبور فعلی">
        <b-form-input trim v-model="oldPassword" type="password"></b-form-input>
      </b-form-group>

      <b-form-group label="رمز عبور جدید">
        <b-form-input
          trim
          v-model="password"
          @input="passStrength"
          type="password"
        ></b-form-input>
        <br />
        <!--============== checking password =========== -->
        <b-row class="w-50">
          <b-col>
            <!-- NOTE check if the pass has more than 8 charector -->
            <p class="pass" :class="{ 'pass--passed': password.length > 7 }">
              <i
                class="frmIcon fa"
                :class="password.length > 7 ? 'fa-check' : 'fa-times'"
              ></i>
              حداقل ۸ نویسه
            </p>
          </b-col>
          <b-col>
            <!-- NOTE check if the pass has uppercase -->
            <p class="pass" :class="{ 'pass--passed': has_uppercase }">
              <i
                class="frmIcon fa"
                :class="has_uppercase ? 'fa-check' : 'fa-times'"
              ></i>
              دارای حروف بزرگ باشد
            </p>
          </b-col>
        </b-row>
        <b-row class="w-50">
          <b-col>
            <!-- NOTE check if the pass has lowercase -->
            <p class="pass" :class="{ 'pass--passed': has_lowercase }">
              <i
                class="frmIcon fa"
                :class="has_lowercase ? 'fa-check' : 'fa-times'"
              ></i>
              دارای حروف کوچک باشد
            </p>
          </b-col>
          <b-col>
            <!-- NOTE check if the pass has number -->
            <p class="pass" :class="{ 'pass--passed': has_number }">
              <i
                class="frmIcon fa"
                :class="has_number ? 'fa-check' : 'fa-times'"
              ></i>
              دارای عدد باشد
            </p>
          </b-col>
        </b-row>

        <!--============== checking password =========== -->
      </b-form-group>
      <b-form-group label="تکرار رمز عبور جدید">
        <b-form-input
          trim
          v-model="repeatPassword"
          type="password"
          aria-describedby="repeat-password"
          :state="checkPassword"
        ></b-form-input>
        <b-form-invalid-feedback id="repeat-password"
          >رمز عبور با تکرار آن همخوانی ندارد</b-form-invalid-feedback
        >
      </b-form-group>
      <b-button
        @click="changePassword()"
        :disabled="isBusy || checkPassword == false"
        >تغییر رمز</b-button
      >
      <!-- NOTE (b-changePass) to change the password -->
    </b-card>
  </div>
</template>

<script>
import md5 from "js-md5";

export default {
  data() {
    return {
      password: "",
      repeatPassword: "",
      oldPassword: "",
      codeSent: false,
      activationCode: "",
      newPass: "",
      repeatNewPass: "",
      countdown: 60,
      sendAgainDisbaled: false,
      busy: false,
      isBusy: false,
      has_number: false,
      has_lowercase: false,
      has_uppercase: false,
      isLoaded: true,
    };
  },
  computed: {
    checkPassword() {
      // NOTE (c-checkPass) to check that the password is not duplicate
      return this.password == this.repeatPassword ? null : false;
    },
    // NOTE this func check if the password has lowecase,uppercase and number
  },
  methods: {
    passStrength() {
      this.has_number = /\d/.test(this.password);
      this.has_lowercase = /[a-z]/.test(this.password);
      this.has_uppercase = /[A-Z]/.test(this.password);
    },
    changePassword() {
      if (
        this.has_number &&
        this.has_lowercase &&
        this.has_uppercase &&
        this.password.length > 7
      ) {
        this.$bvModal.show("loading");
        this.isLoaded = false;
        // NOTE (m-changePassword) to change the password
        this.isBusy = true;
        this.$http
          .post(
            this.baseUrl + "/setad/manager/managerPassword",
            {
              password: md5(this.password),
              oldPassword: md5(this.oldPassword),
            },
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
            }
          )
          .then((res) => {
            this.$bvModal.hide("loading");
            this.isLoaded = true;
            this.isBusy = false;
            this.password = "";
            this.repeatPassword = "";
            this.oldPassword = "";
            this.toast(res.data, "success");
          })
          .catch((err) => {
            this.$bvModal.hide("loading");
            this.isLoaded = true;
            this.isBusy = false;
            console.log(err);
            this.toast(err.response.data, "error");
          });
      } else {
        this.toast(
          "لطفا جهت حفظ امنیت اطلاعات خود موارد خواسته شده را در رمز خود اعمال کنید",
          "error"
        );
      }
    },
  },
  mounted() {
    setTimeout(() => {
      if (!this.isLoaded) {
        const title = (
          <div>
            <h5 class="text-center">...کندی سرعت اینترنت</h5>
            <span>
              به نظر میرسد سرعت اینترنت شما کمی کند است. لطفا برای بارگذاری
              اطلاعات بیشتر صبر کنید یا صفحه را رفرش کنید
            </span>
          </div>
        );
        this.toast(title, "warning");
        this.$bvModal.hide("loading");
      }
    }, this.isLoadedTimeOut);
  },
};
</script>

<style>
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}

.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: #d6bbc0;
  border-bottom: 1px solid #c8ced3;
}
.color {
  background-color: #0c4961;
  color: white;
}
.myselect2 {
  width: 100%;
}
/* pass validation style */
.pass {
  font-size: 13px;
}
.pass--passed {
  color: #717b85;
}
.frmIcon {
  color: #eb0029;
}
.pass--passed .frmIcon {
  color: #0fa140;
}
</style>
